import { useWatch } from "react-hook-form";
import { SegmentedControl } from "./SegmentedControl.jsx";

const accessibilityOptions = [
  { value: "exclude", label: "No" },
  { value: "only", label: "Yes" },
  { value: "any", label: "Either" },
];

const validSiteTypes = ["rv", "tent", "backcountry", "group", "lodging"];

const matchesSiteType = (site, siteType) => {
  if (siteType === "rv" || siteType === "tent") {
    return site.type.includes(siteType);
  }

  return site.type === siteType;
};

export function AccessibilityInput({ name, facility, formContext, ...rest }) {
  const { control } = formContext;
  const siteType = useWatch({ name: "siteType", control });

  if (!siteType || !validSiteTypes.includes(siteType)) {
    return null;
  }

  const hasAccessibleSites = facility.sites
    .filter((site) => matchesSiteType(site, siteType))
    .some((site) => site.isAccessible);

  if (!hasAccessibleSites) {
    return null;
  }

  return (
    <SegmentedControl
      control={control}
      name={name}
      label="Do you need an accessible site?"
      options={accessibilityOptions}
      size="sm"
      {...rest}
    />
  );
}
